import React from "react";

import { clsx } from "clsx";
import { Loading } from "ui-svgs";

type Props = {
  fullScreenOverlay?: boolean;
  containedOverlay?: boolean;
  className?: string;
  useSVG?: boolean;
  fill?: string;
};

const Loader = ({ fullScreenOverlay, containedOverlay, className, useSVG, fill }: Props) => (
  <>
    <div
      className={clsx({
        "the-loading": true,
        [`${className ? className : ""}`]: className,
      })}
    >
      {!useSVG ? (
        <div className="loader" />
      ) : (
        <div className="the-loader">
          <Loading fill={fill} />
        </div>
      )}
      {containedOverlay && <div className="the-overlay overlay" />}
    </div>

    {fullScreenOverlay && <div className="the-overlay overlay" />}
  </>
);

export default Loader;
